import type { SessionHydration_Asset_Image } from '~/graphql/types';
import { useRecoilValue } from 'recoil';
import { assetsState } from '~/state/assets';

/**
 * Assets are only set once around the app, use this hook to consume image assets
 */
const useImageAssets = (): Array<SessionHydration_Asset_Image> => {
  const assets = useRecoilValue(assetsState);
  return assets.images;
};

export default useImageAssets;
